<template>
  <div
    class="backlog-date-picker"
    v-click-outside="onClickOutside"
    >

    <div class="backlog-date-picker-header">
      <v-btn @click="date_type = 'start'" width="50%" :color="date_type === 'start'?'grey darken-3':'grey darken-4'" style="border-radius: 0px;">start</v-btn>
      <v-btn
        @click="date_type = 'end'"
        width="50%"
        :color="date_type === 'end'?'grey darken-3':'grey darken-4'"
        style="border-radius: 0px;"
        :disabled="date.start === ''"
        >
        end
      </v-btn>
    </div>
    <v-date-picker
      :value="date[date_type]"
      @input="selectDate($event)"
      no-title scrollable
      :locale-first-day-of-year="4"
      :allowed-dates="isAllowedDate"
      :first-day-of-week="getFirstDayOfWeekInteger($route.params.project_id)"
      color="blue lighten-1"
      :show-current="true"
      show-week
      >
      <v-spacer/>
      <v-btn @click.prevent.stop="$emit('clickRemove')">Remove Date</v-btn>
      <v-btn @click.prevent.stop="$emit('clickClose')">Close</v-btn>
    </v-date-picker>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: ['date', 'wbworkpackage_position'],
    data: () => ({
      date_type: 'start',
    }),
    computed: {
      ...mapGetters('ProjectCalendar', [
        'getCalendar',
        'getFirstDayOfWeekInteger'
      ]),
      allowed_start_dates() {
        let dates = []
        this.getCalendar(this.$route.params.project_id).takt_times.forEach(takt_time => {
          dates.push(takt_time.dates[0].toISOString().substring(0,10));
        });
        return dates;
      },
      allowed_end_dates() {
        let dates = []
        let start_date = this.getCalendar(this.$route.params.project_id).takt_times[this.wbworkpackage_position-1].dates[0];
        this.getCalendar(this.$route.params.project_id).takt_times.forEach(takt_time => {
          if (start_date.getTime() <= takt_time.dates[0].getTime()) {
            dates.push(takt_time.dates[takt_time.dates.length-1].toISOString().substring(0,10));
          }
        });
        return dates;
      },
    },
    methods: {
      onClickOutside() {
        this.$emit('clickOutside')
      },
      isAllowedDate(date) {
        if (this.date_type === 'end') {
          return this.allowed_end_dates.includes(date);
        } else {
          return this.allowed_start_dates.includes(date);
        }
      },
      selectDate(evt) {
        if (this.date_type === 'end') {
          this.$emit('updateLength', this.allowed_end_dates.indexOf(evt) + 1);
        } else {
          this.$emit('updatePosition', this.allowed_start_dates.indexOf(evt) + 1);
        }
      }
    }
  }
</script>
<style>
  .backlog-date-picker {
    position: absolute;
    top: calc(100% + 5px);
    right: 0px;
    background-color: #212121;
    z-index: 100;
  }
  .backlog-date-picker-header {
    display: flex;
  }
</style>
